export const SHOW_MODAL_BACKDROP = 'global/SHOW_MODAL_BACKDROP'
export const UPDATE_USER_PROFILE_NAME = 'global/UPDATE_USER_PROFILE_NAME'
export const TOGGLE_SIDEBAR_NAV = 'global/TOGGLE_SIDEBAR_NAV'
export const TOGGLE_TOP_NAVBAR = 'global/TOGGLE_TOP_NAVBAR'
export const UP_SET_PROFILE = 'up/UP_SET_PROFILE'
export const UP_UPDATE_NAME = 'up/UP_UPDATE_NAME'
export const UP_LOAD_PROFILE = 'up/UP_LOAD_PROFILE'
export const UP_UPDATE_ALL_PRACTICES_DASHBOARD_ON_LOGIN_SETTING = 'up/UP_UPDATE_ALL_PRACTICES_DASHBOARD_ON_LOGIN_SETTING'
export const AUTH_GET_USER_AUTHORITIES = 'auth/AUTH_GET_USER_AUTHORITIES'
